 //상품이미지들 LazyLoad
jQuery("img.lazy").lazyload();


function on_submit_add_to_cart(form,event) {

  event.preventDefault();

  jQuery.ajax({
    type: "POST",
    url: "/cart/add",
    data: jQuery(form).serialize(),
    success: function() {
      var snack_msg = "Your item has been added.";
      var snack_link = "Go to cart >";

      show_snackbar_with_link(snack_msg,snack_link,"/cart");
    }
  })
}



